import Button from '@preqin/ui-components/cjs/core/Buttons/Button';
import { Launch } from '@preqin/ui-components/cjs/icons/operations';

interface Props {
  label: string;
  link: string;
  type?: 'primary' | 'secondary';
}

export const ContactUsButton = ({ label, link, type = 'primary' }: Props) => {
  return <Button type={type} text={label} handleOnClick={() => window.open(link, '_blank')} iconEnd={Launch} />;
};
